import {AddOrEditVoyageData} from "views/ProcessDetails/refactor/components/ProcessBoarding/components/Voyages/AddOrEditVoyageModal/AddOrEditVoyageModal";
import {Voyage} from "views/ProcessDetails/refactor/types/voyages.types";
import {
  ID_COLLECT_VOYAGE,
  ID_DELIVERY_VOYAGE,
  ID_FINAL_DESTINATION_VOYAGE,
  ID_INITIAL_VOYAGE,
  ID_RECEIVING_LOCATION,
  ID_TRANSHIPMENT_TYPE_VOYAGE,
} from "views/ProcessDetails/utils/constants";

const voyageTypeOrder = new Map<number, number>([
  [ID_COLLECT_VOYAGE, 1],
  [ID_INITIAL_VOYAGE, 2],
  [ID_TRANSHIPMENT_TYPE_VOYAGE, 3],
  [ID_FINAL_DESTINATION_VOYAGE, 4],
  [ID_RECEIVING_LOCATION, 5],
  [ID_DELIVERY_VOYAGE, 6],
]);

const normalizeIdAndName = (value?: {
  id?: number | null;
  name?: string | null;
}) =>
  value?.id || value?.name
    ? {id: value.id ?? null, name: value.name ?? null}
    : null;

const createDraftVoyage = (data: AddOrEditVoyageData): Voyage => ({
  id: data.id as number,
  cargoLoad: data.cargoLoad ?? null,
  cargoUnload: data.cargoUnload ?? null,
  createdAt: "",
  updatedAt: "",
  origin: normalizeIdAndName(data.origin ?? undefined),
  destination: normalizeIdAndName(data.destination ?? undefined),
  estimatedCargoLoad: data.estimatedCargoLoad ?? null,
  estimatedCargoUnload: data.estimatedCargoUnload ?? null,
  placeDelivery: data.placeDelivery ?? null,
  placePickup: data.placePickup ?? null,
  precedence: data.precedence ?? 0,
  typeVoyage: normalizeIdAndName(data.typeVoyage ?? undefined),
  vessel: normalizeIdAndName(data.vessel ?? undefined),
  voyageFlight: data.voyageFlight ?? null,
  typeService: data.typeService ?? null,
  bindingDate: data.bindingDate ?? null,
  grantDate: data.grantDate ?? null,
  transportCompany: data?.transportCompany ?? null,
  observation: data?.observation ?? null,
});

const shouldKeepOriginalOrigin = (voyage: Voyage, index: number) => {
  if (voyage.typeVoyage?.id === ID_COLLECT_VOYAGE) {
    return true;
  }

  if (index === 0 || voyage.typeVoyage?.id === ID_INITIAL_VOYAGE) {
    return true;
  }

  return false;
};

export const buildVoyagesDraftAfterInsert = (
  voyages: Voyage[],
  data: AddOrEditVoyageData,
): Voyage[] => {
  const nextVoyages = [...voyages, createDraftVoyage(data)];
  const orderedVoyages = nextVoyages
    .map((voyage, index) => ({voyage, index}))
    .sort((a, b) => {
      const orderA = voyageTypeOrder.get(a.voyage.typeVoyage?.id ?? 0) ?? 999;
      const orderB = voyageTypeOrder.get(b.voyage.typeVoyage?.id ?? 0) ?? 999;

      if (orderA !== orderB) {
        return orderA - orderB;
      }

      return a.index - b.index;
    })
    .map(({voyage}) => voyage);

  return orderedVoyages.map((voyage, index, currentVoyages) => {
    if (voyage.typeVoyage?.id === ID_COLLECT_VOYAGE) {
      return {
        ...voyage,
        origin: null,
        precedence: index + 1,
      };
    }

    if (shouldKeepOriginalOrigin(voyage, index)) {
      return {
        ...voyage,
        precedence: index + 1,
      };
    }

    return {
      ...voyage,
      origin: currentVoyages[index - 1]?.destination ?? null,
      precedence: index + 1,
    };
  });
};
